<template>
    <v-card :loading="loading" mx-4>
        <v-skeleton-loader
            v-if="loading"
            type="card"
        ></v-skeleton-loader>
        <v-tabs
            v-else
            v-model="tab"
            background-color="primary"
            dark
        >
            <v-tab key="general">
                Informatii generale
            </v-tab>
            <v-tab v-if="id" key="file">
                Fisa Furnizorului
            </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
            <v-tab-item key="general">
                <v-card class="px-4 py-4" flat>
                    <v-text-field
                        v-model="form.display_name"
                        v-validate="'required'"
                        :error-messages="errorMessages('display_name')"
                        :class="{ 'error--text': hasErrors('display_name') }"
                        class="primary--text"
                        name="display_name"
                        label="Denumire"
                        data-vv-name="display_name"
                        counter="255"
                    />

                    <v-divider
                        class="mx-4"
                        vertical
                    ></v-divider>
                    <v-subheader>
                        Permisiuni
                    </v-subheader>
                    <v-select
                        v-model="form.permissions"
                        :items="permissions"
                        item-value="id"
                        item-text="display_name"
                        :multiple="true"
                        :error-messages="errorMessages('permissions')"
                        :class="{ 'error--text': hasErrors('permissions') }"
                        class="primary--text"
                        name="permissions"
                        label="Permisiuni"
                        data-vv-name="permissions"
                    />

                    <v-btn
                        :loading="form.busy"
                        :disabled="errors.any() || form.busy"
                        block
                        color="success"
                        @click="submit()"
                    >
                        Salveaza
                        <v-icon right>
                            save
                        </v-icon>
                    </v-btn>
                </v-card>
            </v-tab-item>

            <v-tab-item key="file">
                <v-card class="px-4 py-4" flat>
                </v-card>
            </v-tab-item>
        </v-tabs-items>
    </v-card>
</template>

<script>
    import validationError from "Mixins/validation-error";
    import {Form} from "vform";
    import swal from "sweetalert2";

    export default {
        mixins: [validationError],
        props: {
            id: {
                type: [Number, String],
                required: false
            }
        },
        data: () => ({
            tab: 'general',
            loading: false,
            permissions: [],
            /* Always Declare Your Form Object */
            form: new Form({
                id: null,
                display_name: null,
                name: null,
                guard: null,
                permissions: []
            }),
        }),
        async mounted() {
            this.loading = true;
            this.permissions = await this.$db.Permission.limit(150).get().then(({data}) => data)
            if(this.id) {
                await this.loadResource()
            }
            this.loading = false;
        },
        methods: {
            async loadResource() {
                let self = this;
                this.loading = true;

                let role = await this.$db.Role.include('permissions').find(this.id).then(({data}) => {
                    data.permissions = data.permissions.map(permission => permission.id)
                    return data
                })
                console.log('role', role)
                self.form = new Form(role)
                this.loading = false
            },
            async submit() {
                let self = this;
                this.$validator.validateAll().then(result => {
                    if (result) {
                        // eslint-disable-next-line
                        self.createOrUpdate();
                    } else {
                        this.showError()
                    }
                });
            },
            async createOrUpdate() {
                let self = this;
                self.form.busy = true;

                var model = new this.$db.Role(self.form);
                if (this.id) {
                    model.id = this.id
                }

                model.save()
                    .then(response => {
                        self.$validator.reset();
                        this.showSuccess();
                        self.$nextTick(() => self.$router.push({name: "admin-users-and-roles-index"}));
                    })
                    .catch(errors => {
                        self.form.errors.set(this.form.extractErrors(errors.response))
                        this.showError()
                    }).finally(() => {
                        self.form.busy = false;
                    });
            }
        }
    };
</script>
